var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSandClockSolid = function SvgSandClockSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.25a.75.75 0 0 0 0 1.5h1.25V8a4.75 4.75 0 0 0 2.188 4 4.748 4.748 0 0 0-2.188 4v3.25H6a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5h-1.25V16a4.75 4.75 0 0 0-2.188-4 4.751 4.751 0 0 0 2.188-4V4.75H18a.75.75 0 0 0 0-1.5H6ZM8.75 8V4.75h6.5V8a3.25 3.25 0 1 1-6.5 0Zm.49 7.089a7.151 7.151 0 0 0-.392.119 3.25 3.25 0 0 1 6.304 0 7.127 7.127 0 0 0-.392-.12c-.758-.206-1.7-.338-2.76-.338-1.06 0-2.002.132-2.76.339Z",
    fill: "currentColor"
  })));
};
export default SvgSandClockSolid;